import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import classnames from 'classnames';
import React from 'react';
import _ from 'underscore';

import {ProcessTaskStatusType} from 'graphql-client/__generated/graphqlGlobalTypes';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export const TASK_STATUS_ICONS: Record<
  ProcessTaskStatusType,
  {icon: BenchlingIconName; name: string; style: {color: string}}
> = {
  [ProcessTaskStatusType.PENDING]: {
    icon: 'request-pending',
    name: 'Pending',
    style: {color: Color.GRAY_600},
  },
  [ProcessTaskStatusType.IN_PROGRESS]: {
    icon: 'request-in-progress',
    name: 'In progress',
    style: {color: Color.BLUE_500},
  },
  [ProcessTaskStatusType.FAILED]: {
    icon: 'status-failed',
    name: 'Failed',
    style: {color: Color.RED_500},
  },
  [ProcessTaskStatusType.CANCELLED]: {
    icon: 'cancelled',
    name: 'Cancelled',
    style: {color: Color.RED_500},
  },
  [ProcessTaskStatusType.INVALID]: {
    icon: 'status-warning',
    name: 'Invalid',
    style: {color: Color.ORANGE_500},
  },
  [ProcessTaskStatusType.COMPLETED]: {
    icon: 'status-success',
    name: 'Completed',
    style: {color: Color.GREEN_600},
  },
  [ProcessTaskStatusType.SKIPPED]: {
    icon: 'forward-step',
    name: 'Skipped',
    style: {color: Color.GRAPE_500},
  },
};

interface TaskStatusIconProps {
  type: ProcessTaskStatusType;
  overrideColor?: string;
}

export default function TaskStatusIcon(props: TaskStatusIconProps): JSX.Element {
  const icon = TASK_STATUS_ICONS[props.type]?.icon;
  const style: object | null = TASK_STATUS_ICON_STYLES[props.type] ?? null;

  let styleOverrides = null;
  if (props.overrideColor) {
    styleOverrides = StyleSheet.create({
      overrideColor: {
        color: props.overrideColor,
      },
    });
  }

  return (
    <BenchlingIcon
      icon={icon}
      className={classnames(css(styles.taskStatusIcon), css(style, styleOverrides?.overrideColor))}
    />
  );
}

export const TASK_STATUS_ICON_STYLES = StyleSheet.create(
  _.mapObject(TASK_STATUS_ICONS, (info) => ({...info.style, marginRight: '6px'}))
);

export const styles = StyleSheet.create({
  taskStatusIcon: {
    height: 14,
    width: 14,
  },
});
